import * as React from 'react';
import { headingSectionNameContext } from './context';
export function useHeadingSectionName() {
    var headingSectionName = React.useContext(headingSectionNameContext);
    return headingSectionName;
}
